export const isPromoToggleManualSet = (search: string) => {
    const params = new URLSearchParams(search)
    return params.has('pos_promo')
}
